export default {
	text: "{changedBy} changed this goal's finish date from {from} to {to}",
};
